module.exports = __webpack_public_path__ + "img/CASO.4d8626c5.png";